<script lang="ts" setup>
const { t } = useI18n()
const route = useRoute()

const localePath = useLocalePath()
const homePath = localePath({ name: 'ticketsOverview-waiting' })

const shouldHomeNavigate = computed(() => route.path !== homePath)

const categories = computed(() => [
  {
    name: t('verticalMenu.tickets.name'),
    items: [
      {
        name: t('verticalMenu.tickets.waitingForResponse'),
        icon: 'material-symbols:hourglass-outline',
        to: localePath({ name: 'ticketsOverview-waiting' }),
      },
      {
        name: t('verticalMenu.tickets.overdue'),
        icon: 'material-symbols:work-history-outline',
        to: localePath({ name: 'ticketsOverview-late' }),
      },
      {
        name: t('verticalMenu.tickets.changesSinceLastLogIn'),
        icon: 'material-symbols:notifications-outline',
        to: localePath({ name: 'ticketsOverview-changed' }),
      },
      {
        name: t('verticalMenu.tickets.all'),
        icon: 'material-symbols:view-list-outline',
        to: localePath({ name: 'ticketsOverview-all' }),
      },
    ],
  },
  /*{ // TODO - future expansion
    name: t('verticalMenu.reports.name'),
    items: [
      {
        name: t('verticalMenu.reports.projectReports'),
        icon: 'material-symbols:monitoring',
        to: localePath({ name: 'issues' }),
      },
      {
        name: t('verticalMenu.reports.invoices'),
        icon: 'material-symbols:payments',
        to: localePath({ name: 'issues' }),
      },
    ],
  },*/
])
</script>

<template>
  <div class="flex min-h-screen">
    <!-- Vertical menu -->
    <div
      class="fixed z-50 min-h-full max-w-56 overflow-x-hidden border-r border-gray-300 bg-gray-100"
    >
      <NuxtLink
        :to="shouldHomeNavigate ? homePath : undefined"
        class="flex w-full border-b border-gray-300 px-8 py-4 text-2xl font-bold no-underline cursor-pointer"
      >
        <span>Solve</span>
        <span class="inline text-orange-500">Point</span>
      </NuxtLink>
      <div class="p-4">
        <NuxtLink class="no-underline" :to="localePath({ name: 'issues-add' })">
          <UButton
            block
            icon="i-heroicons-plus-circle-20-solid"
            class="text-base"
          >
            {{ t('verticalMenu.tickets.newTicket') }}
          </UButton>
        </NuxtLink>

        <div v-for="category in categories" :key="category.name">
          <span class="flex w-full pb-2 pt-4 text-lg font-bold">
            {{ category.name }}
          </span>
          <div class="flex flex-col gap-2">
            <div v-for="item in category.items">
              <UButton
                variant="soft"
                class="w-full border border-orange-300 text-base"
                :class="route.path === item.to ? 'bg-orange-200 hover:bg-orange-200' : ''"
                :icon="item.icon"
                @click="route.path !== item.to && navigateTo(item.to)"
              >
                {{ item.name }}
              </UButton>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Main part -->
    <div class="flex-1">
      <!-- Horizontal menu -->
      <div
        class="fixed z-40 w-full border-b border-gray-300 bg-gray-100 py-4 pl-56"
      >
        <div class="container flex items-center justify-between">
          <div id="headingOfSubPage"></div>
          <div class="flex">
            <IssuesSearch />
            <Icon
              name="material-symbols:help-rounded"
              class="mx-8 size-8 cursor-pointer"
              @click="navigateTo(localePath({ name: 'help' }))"
            ></Icon>
            <UserSettings />
          </div>
        </div>
      </div>
      <!-- Content -->
      <div class="pl-56 pt-16">
        <slot />
      </div>
    </div>
  </div>
</template>
